import { useMutation } from '@tanstack/react-query';
import { updateTag } from 'shared/services/backend-api';
import { Tag } from 'shared/types/tag';

export const useUpdateTagMutation = () =>
  useMutation({
    mutationFn: async (tag: Partial<Tag> & Pick<Tag, 'id'>) => updateTag(tag),
  });
